import WithLayout from '../WithLayout';
import { AuthorTemplate } from '../../components/responsive/templates/AuthorTemplate';

export default WithLayout(AuthorTemplate);
